module.exports = __webpack_public_path__ + "img/august-black.9379c0ad.svg";